(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SPACE } from "../../constants/style.js";
import { HtmlElement } from "../base";
import { StyleContext } from "../../context.js";
import { Icon } from "../icons";
var InnerButton = styled(HtmlElement).withConfig({
  displayName: "Button__InnerButton",
  componentId: "sc-1maf22-0"
})([""]);

var Wrapper = function Wrapper(props) {
  return React.createElement(InnerButton, _extends({}, props, {
    forwardedAs: "button"
  }));
};

var StyledButton = styled(Wrapper).withConfig({
  shouldForwardProp: function shouldForwardProp(prop, defaultValidator) {
    return ['color'].includes(prop) === false && defaultValidator(prop);
  }
}).withConfig({
  displayName: "Button__StyledButton",
  componentId: "sc-1maf22-1"
})(["text-decoration:none;white-space:nowrap;border-radius:4px;padding:", ";border-width:2px;font-family:", ";", " font-size:", ";font-weight:400;cursor:pointer;height:", ";padding:0 ", ";border-style:solid;&:active{border-style:solid;}display:flex;align-items:center;justify-content:center;margin:0 ", ";&:first-child{margin-left:0;}&:last-child{margin-right:0;}", " background:", ";border-color:", ";color:", ";", ""], function (props) {
  return props.icon ? '0 16px 0 12px' : '0 16px';
}, function (props) {
  return props.theme.styles.fonts.primary;
}, function (props) {
  return props.fullWidth ? 'width: 100%;' : '';
}, function (props) {
  switch (props.size) {
    case 'xs':
      return '14px';

    case 'sm':
    case 'md':
      return '16px';

    case 'lg':
      return '20px';

    default:
      return '16px';
  }
}, function (props) {
  switch (props.size) {
    case 'xs':
      return '24px';

    case 'sm':
      return '40px';

    case 'md':
      return '48px';

    case 'lg':
      return '64px';

    default:
      return '48px';
  }
}, function (props) {
  switch (props.size) {
    case 'xs':
      return '12px';

    case 'sm':
      return '16px';

    case 'md':
      return '20px';

    case 'lg':
      return '32px';

    default:
      return '24px';
  }
}, SPACE.sm, function (props) {
  return props.padding ? "padding: ".concat(props.padding, ";") : null;
}, function (props) {
  var color = props.color,
      variant = props.variant;

  if (variant === 'outlined' || variant === 'transparent') {
    return 'transparent';
  } else if (variant === 'filled') {
    if (color === 'primary') {
      return props.theme.styles.colors.primaryColor;
    } else if (color === 'secondary') {
      return props.theme.styles.colors.secondaryColor;
    } else if (color === 'plain') {
      return props.theme.styles.colors.primaryFadedColor;
    } else if (color === 'danger') {
      return props.theme.styles.colors.danger;
    } else if (color === 'negative') {
      return props.theme.styles.colors.negative;
    } else if (color === 'warning') {
      return props.theme.styles.colors.warning;
    } else if (color === 'positive') {
      return props.theme.styles.colors.positive;
    } else {
      return props.theme.styles.colors.anonymous;
    }
  } else if (color === 'primary') {
    return props.theme.styles.colors.primaryColor;
  }
}, function (props) {
  var color = props.color,
      variant = props.variant;

  if (variant === 'outlined' || variant === 'filled') {
    if (color === 'primary') {
      return props.theme.styles.colors.primaryColor;
    } else if (color === 'plain') {
      return props.theme.styles.colors.primaryFadedColor;
    } else if (color === 'secondary') {
      return props.theme.styles.colors.secondaryColor;
    } else if (color === 'danger') {
      return props.theme.styles.colors.danger;
    } else if (color === 'negative') {
      return props.theme.styles.colors.negative;
    } else if (color === 'warning') {
      return props.theme.styles.colors.warning;
    } else if (color === 'positive') {
      return props.theme.styles.colors.positive;
    } else {
      return props.theme.styles.colors.anonymous;
    }
  } else if (variant === 'transparent') {
    return 'transparent';
  } else if (color === 'primary') {
    return props.theme.styles.colors.primaryColor;
  }
}, function (props) {
  var color = props.color,
      variant = props.variant;

  if (color === 'anonymous' && props.theme.styles.colors.anonymousText) {
    return props.theme.styles.colors.anonymousText;
  } else if (color === 'plain') {
    return props.theme.styles.colors.plain;
  } else if (variant === 'filled') {
    if (color === "primary") return props.theme.styles.colors.bodyFilledTextColor;else if (color === "secondary") {
      return props.theme.styles.colors.bodyBackgroundColor;
    }
    return props.theme.styles.colors.white;
  } else if (color === 'primary') {
    return props.theme.styles.colors.primaryColor;
  } else if (color === 'secondary') {
    return props.theme.styles.colors.secondaryColor;
  } else if (color === 'danger') {
    return props.theme.styles.colors.danger;
  } else if (color === 'negative') {
    return props.theme.styles.colors.negative;
  } else if (color === 'warning') {
    return props.theme.styles.colors.warning;
  } else if (color === 'positive') {
    return props.theme.styles.colors.positive;
  } else {
    return props.theme.styles.colors.anonymous;
  }
}, function (props) {
  return Boolean(props.disabled) && 'opacity: 0.5; cursor: default;';
});
var StyledLeftIcon = styled(Icon).withConfig({
  displayName: "Button__StyledLeftIcon",
  componentId: "sc-1maf22-2"
})(["margin-right:", ";margin-left:-", ";"], SPACE.md, SPACE.sm);
var StyledRightIcon = styled(Icon).withConfig({
  displayName: "Button__StyledRightIcon",
  componentId: "sc-1maf22-3"
})(["margin-left:", ";"], SPACE.md);
var colorOptions = ['plain', 'anonymous', 'primary', 'secondary', 'warning', 'negative', 'positive', // TODO: REMOVE
'info', 'warning', 'error', 'danger'];
var variantOptions = ['filled', 'outlined', 'transparent'];

var Button = function Button(props) {
  var dropdown = props.dropdown,
      icon = props.icon,
      size = props.size;
  var styleContext = useContext(StyleContext); // Check if variant and color values are passed directly as props
  // and if they do, they will override the ones set in color or
  // variant props.

  var variant = variantOptions.reduce(function (acc, curr) {
    return acc ? acc : props.hasOwnProperty(curr) ? curr : null;
  }, null);
  var color = colorOptions.reduce(function (acc, curr) {
    return acc ? acc : props.hasOwnProperty(curr) ? curr : null;
  }, null);
  var visual = {
    color: color || props.color,
    variant: variant || props.variant
  };
  return React.createElement(StyledButton, _extends({}, props, visual, {
    styleContext: styleContext
  }), icon ? React.createElement(StyledLeftIcon, {
    name: icon,
    size: size
  }) : null, props.children, dropdown ? React.createElement(StyledRightIcon, {
    name: "dropdown"
  }) : null);
};

__signature__(Button, "useContext{styleContext}");

Button.defaultProps = {
  color: 'plain',
  variant: 'filled',
  size: 'md'
};
Button.propTypes = {
  color: PropTypes.oneOf(colorOptions),
  variant: PropTypes.oneOf(variantOptions),
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
};
var _default = Button;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(InnerButton, "InnerButton", "/home/vsts/work/1/s/src/components/buttons/Button.js");
  reactHotLoader.register(Wrapper, "Wrapper", "/home/vsts/work/1/s/src/components/buttons/Button.js");
  reactHotLoader.register(StyledButton, "StyledButton", "/home/vsts/work/1/s/src/components/buttons/Button.js");
  reactHotLoader.register(StyledLeftIcon, "StyledLeftIcon", "/home/vsts/work/1/s/src/components/buttons/Button.js");
  reactHotLoader.register(StyledRightIcon, "StyledRightIcon", "/home/vsts/work/1/s/src/components/buttons/Button.js");
  reactHotLoader.register(colorOptions, "colorOptions", "/home/vsts/work/1/s/src/components/buttons/Button.js");
  reactHotLoader.register(variantOptions, "variantOptions", "/home/vsts/work/1/s/src/components/buttons/Button.js");
  reactHotLoader.register(Button, "Button", "/home/vsts/work/1/s/src/components/buttons/Button.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/buttons/Button.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();